"use strict";
window.up.compiler('.js-center_scroll', element => {
    var _a, _b;
    const height = element.scrollHeight;
    const width = element.scrollWidth;
    const boxHeight = ((_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.scrollHeight) || height;
    const boxWidth = ((_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.scrollWidth) || width;
    element.scrollTo((width - boxWidth) / 2, (height - boxHeight) / 2);
});
